import {Adresse} from "@/ts/interface/compte";
import {Livraison} from "@/ts/interface/detailOffre";

import {findDataArticle} from "./findDataArticle";

// Si contient une adresse_id en paramètre,
// Cherche et retourne l'adresse,
// Sinon retourne l'adresse par defaut.
export function findAdresse(
  adresses?: Adresse[],
  adresse_id: number | string | null = null,
): Adresse | undefined {
  let findAdresse = undefined;
  if (adresses) {
    if (adresse_id) {
      findAdresse = adresses?.find(adresse => {
        return adresse.adresse_id === adresse_id;
      });
    } else {
      findAdresse = adresses?.find(adresse => {
        return adresse.is_default;
      });
    }
  }
  return findAdresse;
}

export function findLivraisonDate(
  livraisons: Livraison[],
  article_id: number,
): string {
  const foundLivraison: Livraison[] = findDataArticle(livraisons, article_id);
  return foundLivraison?.[0]?.fournisseurs[0]?.dates_livraison[0].fin;
}
